import { memo } from 'react';
import styled from '@emotion/styled';
import { IconButton, tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useSelector, useStore } from '@hotjar/recordings/src/store/player/context';
import { toggleSidePanel } from '@hotjar/recordings/src/features/Playbacks/utils';
import { withHighlight } from '../withHighlight';
import { EventsBinding } from '../Controls/KeyboardShortcutEvents';

const ExpandCollapse = styled(IconButton)`
  ${({ isExpanded }) =>
    isExpanded &&
    `
      &, &:hover {
       background: ${tokens.color.cobalt_200};
       border-radius: ${tokens.radius.m};
      }
    `};
`;

const ExpandCollapseBtn = ({ disabled }) => {
  const { t } = useTranslation();
  const playerStore = useStore();
  const { showSidePanel } = useSelector((state) => ({ showSidePanel: state.showSidePanel }));

  const tooltipText = !showSidePanel
    ? t('common:player.expand-sidebar')
    : t('common:player.collapse-sidebar');

  return (
    <ExpandCollapse
      size="s"
      icon="info"
      tooltipText={tooltipText}
      description={tooltipText}
      kind="ghost"
      isDisabled={disabled}
      onClick={() => toggleSidePanel(playerStore, !showSidePanel)}
      isExpanded={showSidePanel}
    />
  );
};

ExpandCollapseBtn.defaultProps = {
  disabled: false,
};

ExpandCollapseBtn.propTypes = {
  disabled: PropTypes.bool,
};

export const ExpandCollapseButton = withHighlight(
  memo(ExpandCollapseBtn),
  EventsBinding.SIDEPANEL_TOGGLE,
);
